export const API_URL: string = 'https://dog.ceo/api'
